module.exports = __webpack_public_path__ + "img/00ec0e0.png";